module.exports = __webpack_public_path__ + "static/media/key.2b2fed86.svg";